// ### Foundation 6.3 Init
$(document).foundation();


// ### Variables
var b = document.body;
var navOpened = false;

/**
* Coin Snacking
*/
// function tournerLaCarte() {
//   var elements = this.parentNode.querySelectorAll("div[class^='card']");
//   for (var i = 0; i < elements.length; i++) {
//     if (elements[i].className === "card-single") {
//       elements[i].className += " rotated";
//     } else {
//       elements[i].className = "card-single";
//     }
//   }
// }
//
// var buttons = document.getElementsByClassName("button");
// for (i = 0; i < buttons.length; i++) {
//   element = buttons[i];
//   element.addEventListener("click", tournerLaCarte);
// }

/**
* Masonry + images Loaded
* + Add more post buttons
*/
var grid = document.querySelector('.masonry');
if( grid ){


  var imgLoad = imagesLoaded(grid);
  var stamp = grid.querySelector('.masonry__stamp');
  var iso = new Isotope( grid, {
    // options
    initLayout: false,
    itemSelector: '.masonry__item',
    stamp: stamp,
    horizontalOrder: true,
    percentPosition: true,
    transitionDuration: 0,
    masonry: {
      columnWidth: '.grid-sizer',
      gutter: '.gutter-sizer'
    },
  });

  iso.on( 'layoutComplete', function( items ){

    grid.classList.add('masonry--loaded');

    var els = [];
    for (var i = 0; i < items.length; i++) {
      els.push(items[i].element)
    }

    var gridDone = function(){
      grid.classList.add('masonry--done');
    }

    TweenMax.staggerTo( els , .7, {
      alpha: 1,
      y: 0,
      ease: Expo.easeOut
    }, .06, gridDone);
  });

  imgLoad.on( 'progress', function( instance, image ) {
    iso.layout();
  });

  iso.layout();

  /**
  * More Posts
  */

  var page = 1;
  var ppp = 5;
  var $btn = $("#plusactualites button");

  $btn.on("click", function (ev) {
    ev.preventDefault();
    $btn.attr("disabled", true);

    $.ajax({
      url : ajaxurl,
      type : 'post',
      data: {
        action: "more_post_ajax",
        offset: (page * ppp) + 1,
        ppp: ppp
      },
      success: function(data, status, xhr){
        page++;
        var response = document.createElement('div');
        response.innerHTML = xhr.responseText;
        var items = response.querySelectorAll('.article');
        for (var i = 0; i < items.length; i++) {
          grid.append(items[i]);
        }
        iso.appended(items);
      },
      complete: function(){
        $btn.attr("disabled", false);
      }
    });
  });

}


/**
* Swiper
* All Swipers init here
*/
// ### Special Home, Interleave  Effect
if( b.classList.contains('home') && document.querySelector('.swiper-container')){

  var interleaveOffset = -.5;
  var interleaveEffect = {

    onProgress: function(swiper, progress){

      for (var i = 0; i < swiper.slides.length; i++){

        var slide = swiper.slides[i];
        var translate, innerTranslate;
        progress = slide.progress;

        if (progress > 0) {
          translate = progress * swiper.width;
          innerTranslate = translate * interleaveOffset;
        }
        else {
          innerTranslate = Math.abs( progress * swiper.width ) * interleaveOffset;
          translate = 0;
        }
        if (i == 0) {
          //console.log(progress + ' <- progress');
        }

        $(slide).css({
          transform: 'translate3d(' + translate + 'px,0,0)'
        });

        $(slide).find('.swiper-slide-inner').css({
          transform: 'translate3d(' + innerTranslate + 'px,0,0)'
        });
      }
    },

    onTouchStart: function(swiper){
      for (var i = 0; i < swiper.slides.length; i++){
        $(swiper.slides[i]).css({ transition: '' });
      }
    },

    onSetTransition: function(swiper, speed) {
      for (var i = 0; i < swiper.slides.length; i++){
        $(swiper.slides[i])
        .find('.swiper-slide-inner')
        .addBack()
        .css({ transition: speed + 'ms' });
      }
    }
  };

  var swiperOptions = {
    loop: true,
    speed: 1200,
    autoplay: 5000,
    grabCursor: true,
    watchSlidesProgress: true,
    mousewheelControl: true,
    keyboardControl: true,
    autoplayDisableOnInteraction: false
  };

  swiperOptions = $.extend(swiperOptions, interleaveEffect);

  var swiper = new Swiper('.swiper-container', swiperOptions);
}

// ### Generic Swipers
// Only one per pages
if( b.classList.contains('page') && document.querySelector('.swiper-container')){

  // Display Nav Btns if slides > 3
  var slides = document.querySelectorAll('.swiper-container .swiper-slide');
  var slidesEnabled = (slides.length > 3) ? true : false;
  if (slidesEnabled){
    var navigationBtns = document.querySelectorAll('.swiper-button-white');
    for (var i = 0; i < navigationBtns.length; i++) {
      navigationBtns[i].style.display = 'block';
    }
  }
  // Default options
  var swiper_opts = {
    slidesPerView: 'auto',
    prevButton: slidesEnabled ? '.swiper-button-prev' : null,
    nextButton: slidesEnabled ? '.swiper-button-next' : null,
    breakpoints: {
      // when window width is <= 1024px
      1024: {
        freeMode: true
      }
    }
  };
  // Custom options for TPL Coin Snacking
  if( b.classList.contains('page-template-coinsnacking') ){
    swiper_opts.effect = 'fade';
    swiper_opts.autoplay = 5000;
    swiper_opts.loop = true;
    swiper_opts.speed = 1200;
  }
  // Swiper Init
  var swiper = new Swiper('.swiper-container', swiper_opts);

}


/**
* Header Menu
*/
var menuContainer = document.querySelector('#menufull');
var menuSplitBg = menuContainer.querySelectorAll('.fullscreen-navigation__bg');
var menuLogos = menuContainer.querySelectorAll('.fullscreen-navigation__logo');
var menuTitles = menuContainer.querySelectorAll('.fullscreen-navigation__title');
var menuSubTitles = menuContainer.querySelectorAll('.fullscreen-navigation__subtitle');
var menuListItems = menuContainer.querySelectorAll('.fullscreen-navigation__menu');
var dash = menuContainer.querySelectorAll('.dash');

var menuReverseCompleted = function(){
  menuContainer.style.display = 'none';
}

var menuTimeLine = new TimelineLite({ paused: true, onReverseComplete: menuReverseCompleted });
menuTimeLine.add('start');
menuTimeLine.add( TweenMax.staggerFromTo(menuSplitBg, .7, {scaleX:0, ease: Power3.easeInOut}, {scaleX:1, ease: Power3.easeInOut}, .15), 'start' );
menuTimeLine.add( TweenMax.staggerFromTo(menuLogos, .6, {y: 60, alpha:0, ease: Power4.easeOut}, {y:0, alpha:1, ease: Power4.easeOut}, .2), 'start+=0.3' );
menuTimeLine.add( TweenMax.staggerFromTo(menuTitles, .6, {y: 60, alpha:0, ease: Power4.easeOut}, {y:0, alpha:1, ease: Power4.easeOut}, .2), 'start+=0.4' );
menuTimeLine.add( TweenMax.staggerFromTo(menuSubTitles, .6, {y: 60, alpha:0, ease: Power4.easeOut}, {y:0, alpha:1, ease: Power4.easeOut}, .2), 'start+=0.5' );
menuTimeLine.add( TweenMax.staggerFromTo(menuListItems, .6, {y: 60, alpha:0, ease: Power4.easeOut}, {y:0, alpha:1, ease: Power4.easeOut}, .06), 'start+=0.6' );
menuTimeLine.add( TweenMax.fromTo(dash, 1, {scaleX:0, ease: Expo.easeOut}, {scaleX:1, ease: Expo.easeOut}), 'start+=0.7' );

$('#trigger-menu').on('click', function(evt){

  evt.preventDefault();

  if(navOpened){
    navOpened = false;
    b.classList.remove('nav-opened');
    //document.ontouchstart = function(e){ return true; } // Enable scroll
    menuTimeLine.timeScale(1.6);
    menuTimeLine.reverse();
  } else {
    navOpened = true;
    b.classList.add('nav-opened');
    //document.ontouchstart = function(e){ e.preventDefault(); } // Disable scroll
    menuContainer.style.display = 'block';
    menuTimeLine.timeScale(1.1);
    menuTimeLine.play();
  }

});


/**
* Cards
*/
if ( b.classList.contains('page-template-coinsnacking') ){

  var cards = document.querySelectorAll('.js-card');
  var cardTimeLine = [];
  var itemOpened = false;

  for (var i = 0; i < cards.length; i++) {
    var item = cards[i];

    // Trigger Btn
    var triggerBtn = item.querySelector('.button');

    // Els to animate
    var front = item.querySelector('.cards__item__front');
    var frontTitle = front.querySelector('.cards__item__title span');
    var back = item.querySelector('.cards__item__back');
    var backTitle = back.querySelector('.cards__item__title span');
    var backBg = back.querySelector('.cards__item__bg');
    var backListItems = back.querySelectorAll('.cards__item__list p');
    var st = new SplitText(backListItems, {type:"lines"});
    var lines = st.lines;
    var backCaution = back.querySelector('.cards__item__caution');

    // Timeline Animation
    cardTimeLine[i] = new TimelineLite({ paused: true });
    cardTimeLine[i].add('start');
    cardTimeLine[i].add( TweenMax.fromTo(frontTitle, .5, {yPercent:0, ease: Power2.easeInOut}, {yPercent:-100, ease: Power2.easeInOut}) );
    cardTimeLine[i].add( TweenMax.fromTo(back, 0, {autoAlpha: 0}, {autoAlpha: 1}), 0);
    cardTimeLine[i].add( TweenMax.fromTo(backBg, .4, {scaleX:0, transformOrigin:'100% 0', ease: Power3.easeOut}, {scaleX:1, transformOrigin:'0 0', ease: Power3.easeOut}), 'start+=0.3' );
    cardTimeLine[i].add('bg');
    cardTimeLine[i].add( TweenMax.fromTo(backTitle, .7, {yPercent:100, autoAlpha:0, ease: Expo.easeOut}, {yPercent:0, autoAlpha:1, ease: Expo.easeOut}), 'bg-=0.1' );
    cardTimeLine[i].add( TweenMax.staggerFromTo(lines, .5, {y:40, autoAlpha:0, ease: Power4.easeOut}, {y:0, autoAlpha:1, ease: Power4.easeOut}, .035), 'bg-=0.1' );
    cardTimeLine[i].add( TweenMax.fromTo(backCaution, .5, {yPercent:100, autoAlpha:0, ease: Expo.easeOut}, {yPercent:0, autoAlpha:1, ease: Expo.easeOut}), '-=0.36' );

    // Trigger Animation
    triggerBtn.addEventListener('click', function(evt){
      evt.preventDefault();

      var currentItemEl = this.parentNode.parentNode;
      var currentItemNb = parseInt(currentItemEl.dataset.id);

      if(currentItemEl.classList.contains('card--opened')){
        currentItemEl.classList.remove('card--opened');
        itemOpened = false;
        cardTimeLine[currentItemNb].reverse();
      } else {
        itemOpened = true;
        currentItemEl.classList.add('card--opened');
        cardTimeLine[currentItemNb].play();
      }
    });
  }

}

/**
* Parallax
*/
var parallaxEls = document.querySelectorAll(".module--parallax");

for (var i = 0; i < parallaxEls.length; i++) {
  var el = parallaxEls[i];
  var parallaxRoot = parallax.create( el );
  var parallaxChild = parallaxRoot.add(el.querySelector('.parallax'), {
    start: {
      y: 0,
    },
    end: {
      y: -250
    }
  });
}
// Add event 'Google Analytics' contact form
$('.page-template-contact form.wpcf7-form .wpcf7-submit').click(function() {
    ga('send', 'event', 'Videos', 'play', 'Fall Campaign');
  });



// ### Responsive tables
if($('.body, .content-subscription').length) {
  $('.body table, .content-subscription table').wrap('<div class="table-container"></div>');
}


// ### Fluid Videos
$( 'iframe[src*="youtube"]' ).wrap("<div class='responsive-embed widescreen'/>");
$( 'iframe[src*="vimeo"]' ).wrap("<div class='responsive-embed widescreen vimeo'/>");
$( 'iframe[src*="dailymotion"]' ).wrap("<div class='responsive-embed widescreen dailymotion'/>");
